import React from "react";
import { IconT } from "types/utils";

const EnvelopeLineIcon = ({ height = "18", width = "18", fill = "currentColor" }: IconT) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M4 6h16v12H4z M4 7l8 6 8-6"
        stroke={fill}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default EnvelopeLineIcon;
